export default (context: any) => {
    // return true if user login
    if (!context.$auth.$state.loggedIn) {
        context.redirect('/login/')
    }
}